import { register, CloudObject, defineProperty } from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class MonitoringEmail extends CloudObject {

    /**
     * Creates an instance of MonitoringEmail.
     *
     * @param {!Transaction} transaction
     * @return {!string} the tag of the created instance
     */
    static create(transaction) {
        return transaction.create(MonitoringEmail);
    }
    
    /**
     * @return {string}
     */
    getEmailSubject() {
        return this.get(MonitoringEmail.emailSubjectProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeEmailSubject($) {
        return this.observe($, MonitoringEmail.emailSubjectProp);
    }

    /**
     * @return {Date}
     */
    getEmailSendTimestamp() {
        return this.get(MonitoringEmail.emailSendTimestampProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<Date>}
     */
    observeEmailSendTimestamp($) {
        return this.observe($, MonitoringEmail.emailSendTimestampProp);
    }

    /**
     * @return {string}
     */
    getImpactedAreas() {
        return this.get(MonitoringEmail.impactedAreasProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeImpactedAreas($) {
        return this.observe($, MonitoringEmail.impactedAreasProp);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setEmailSubject(transaction, instance, value) {
        transaction.update(instance, MonitoringEmail.emailSubjectProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {Date} value
     */
    static setEmailSendTimestamp(transaction, instance, value) {
        transaction.update(instance, MonitoringEmail.emailSendTimestampProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setImpactedAreas(transaction, instance, value) {
        transaction.update(instance, MonitoringEmail.impactedAreasProp, value);
    }

}

// Hardcoded tags
register('0195f129a94bcde68419', MonitoringEmail);
MonitoringEmail.emailSubjectProp = defineProperty('0195f129c5adabba3e72');
MonitoringEmail.emailSendTimestampProp = defineProperty('0195f12a3cbb5272f00e');
MonitoringEmail.impactedAreasProp = defineProperty('0195f12af938f23451de');
